var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"library",attrs:{"flex":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"pb-4":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{attrs:{"app":""}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }